import normalizeTriggerItemId from '@/lib/threads/normalizeTriggerItemId.js';

const removeTriggerItemFromRequestPayload = ({ state, payload } = {}) => {
  const normalizedTriggerId = normalizeTriggerItemId(payload?.meta?.triggerId || payload?.data?.triggerId || payload?.data?.trigger?.id);

  if (!normalizedTriggerId) {
    return state;
  }

  const previousTriggerItems = Array.isArray(state?.triggerItems) ? state.triggerItems : [];
  const nextTriggerItems = previousTriggerItems.filter((triggerItem) => normalizeTriggerItemId(triggerItem?.id) !== normalizedTriggerId);

  if (nextTriggerItems.length === previousTriggerItems.length) {
    return state;
  }

  return {
    ...state,
    triggerItems: nextTriggerItems
  };
};

export default removeTriggerItemFromRequestPayload;
